<mat-toolbar color="primary">
  <mat-toolbar-row class="el-container">
    <ng-content
      selector=".menu-toggle-btn"
      *ngIf="
        isTelesalesMode ||
        isAdminMode ||
        authenticator.route !== 'authenticated'
      "
    ></ng-content>
    <a
      class="logo"
      [routerLink]="
        isAdminMode
          ? '/admin'
          : isTelesalesMode
          ? '/telesales/partner-registration'
          : '/home'
      "
    >
      <img
        [alt]="'HEADER.LOGO' | translate"
        src="assets/pics/easylot-logo.png"
        alt=""
      />
    </a>

    <div
      class="use-case-menu header-menu-container"
      *ngIf="authenticator.route !== 'authenticated'; else authenticated"
    >
      <a [routerLink]="'/modules'" mat-flat-button color="primary">{{
        "HEADER.BTN.MENU_TITLES.MODULES" | translate
      }}</a>
      <a [routerLink]="'/prices'" mat-flat-button color="primary">{{
        "HEADER.BTN.MENU_TITLES.PRICES" | translate
      }}</a>
      <a [routerLink]="'/contact'" mat-flat-button color="primary">{{
        "HEADER.BTN.MENU_TITLES.CONTACT" | translate
      }}</a>
      <a [routerLink]="'/founders'" mat-flat-button color="primary">{{
        "HEADER.BTN.MENU_TITLES.ABOUT" | translate
      }}</a>
    </div>
    <ng-template #authenticated>
      <ul
        class="use-case-menu"
        *ngIf="roles.length && !isAdminMode && !isTelesalesMode"
      >
        <li
          class="context-list-item"
          [class.animation-ready]="switcherReady"
          [ngClass]="(switcherOpened$ | async) ? 'centered' : 'normal'"
        >
          <app-context #context></app-context>
        </li>
        <li>
          <app-header-menu
            [ngStyle]="{
              'margin-left': (switcherOpened$ | async) ? 0 : margin + 'px'
            }"
            *ngIf="roles.length && !isAdminMode && !isTelesalesMode"
          ></app-header-menu>
        </li>
      </ul>
    </ng-template>
    <ng-container
      *ngIf="authenticator.route === 'authenticated'; else loggedOutMenu"
    >
      <app-user-menu class="app-user-menu ms-auto me-3"></app-user-menu>
      <a
        mat-icon-button
        *ngIf="!isAdminMode && !isTelesalesMode"
        [routerLink]="'/buying/order-list'"
        class="order-link"
      >
        <mat-icon class="order-link__icon" fontSet="material-icons-outlined"
          >shopping_cart</mat-icon
        >
      </a>
      <app-diagnostic-trigger></app-diagnostic-trigger>
    </ng-container>
    <ng-template #loggedOutMenu>
      <app-logged-out-menu></app-logged-out-menu>
    </ng-template>
  </mat-toolbar-row>
  <mat-toolbar-row
    class="context-row"
    *ngIf="(siteSelected$ | async) && screenWidth <= 1140"
  >
    <app-context #context></app-context>
  </mat-toolbar-row>
</mat-toolbar>
